module.exports = __webpack_public_path__ + "static/b3-82d1138c719ac60a8ad63461ca904061.jpg";